import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Introduction } from './components/sections/Introduction';
import { Transformation } from './components/sections/Transformation';
import { Problems } from './components/sections/Problems';
import { Volumes } from './components/sections/Volumes';
import { Resources } from './components/sections/Resources';
import { Bonuses } from './components/sections/Bonuses';
import { CompleteOffer } from './components/sections/CompleteOffer';
import { PriceCTA } from './components/sections/PriceCTA';
import { SpecialOffer } from './components/sections/SpecialOffer';
import { Confidence } from './components/sections/Confidence';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans" data-id="element-0" data-mp="3rc9f0ac2njyt">
      <MetaPixel data-id="element-1" data-mp="3recerm310rgq" />
      <Hero data-id="element-2" data-mp="5yk6vxnnffx" />
      <main data-id="element-3" data-mp="5orh0l86u6j">
        <Introduction data-id="element-4" data-mp="67z9oh5w26u" />
        <Transformation data-id="element-5" data-mp="4n6a3ahwrb3" />
        <Problems data-id="element-6" data-mp="82kz509bybz" />
        <Volumes data-id="element-7" data-mp="2zl3azit8d249" />
        <Resources data-id="element-8" data-mp="2zllen0i82im7" />
        <Bonuses data-id="element-9" data-mp="2zm4wyibsb90r" />
        <CompleteOffer data-id="element-10" data-mp="2zmo6pbra6r3p" />
        <PriceCTA data-id="element-11" data-mp="2zng14j956ise" />
        <SpecialOffer data-id="element-12" data-mp="33mf25srr5vek" />
        <Confidence data-id="element-13" data-mp="33lx0ggmbmoz9" />
        <Testimonials data-id="element-14" data-mp="33n6zp94wu37h" />
        <Author data-id="element-15" data-mp="33orjc3pos1qk" />
        <FAQ data-id="element-16" data-mp="38lrq6gud18iq" />
        <FinalCTA data-id="element-17" data-mp="38l8hzruihyhw" />
      </main>
      <Footer data-id="element-18" data-mp="38l04pyuh8r66" />
      <FloatingCTA data-id="element-19" data-mp="38kgl8dp6huq1" />
      <PurchasePopup data-id="element-20" data-mp="38o4h3ji3it7x" />
    </div>;
}